import { render, staticRenderFns } from "./SimpleBarColumn.vue?vue&type=template&id=01c5e3c4&scoped=true"
import script from "./SimpleBarColumn.vue?vue&type=script&lang=js"
export * from "./SimpleBarColumn.vue?vue&type=script&lang=js"
import style0 from "./SimpleBarColumn.vue?vue&type=style&index=0&id=01c5e3c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c5e3c4",
  null
  
)

export default component.exports